<div (appHovered)="isCardHovered = $event" [ngStyle]="getBackgroundImageWithGradient()" class="brand-card"
     id="brand-card-{{slug}}">
  <!-- a tag for SEO purpose -->
  <a [attr.href]="brandUrl" style="display: none;"></a>
  <div class="info">
    <img [src]="logo" alt="{{ slug }} logo" loading="lazy">
  </div>
</div>

